import { Divider } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import OptionsSameDate from './OptionsSameDate';


const InterestFormOptions = () => {
  const { t } = useTranslation();
  return  (
    <>
      <Divider>{t('options')}</Divider>
      <OptionsSameDate />
    </>
  );
};


export default InterestFormOptions;




